import { ErrorNumber, JobMatchValue } from './Enums';

// Max Results
export const serverApiMaxResults = 50;
export const tableDefaultResultsPerPage = 10;

export const oneSecondMilli = 1000;
export const oneMinuteMilli = 60 * oneSecondMilli;
export const oneHourMilli = 60 * oneMinuteMilli;
export const serverApiMaxSetSize = 50;
export const teamStylesMaxSetSize = 100;
export const analyticsMaxSetSize = 100;

/* Time */
// Days
export const oneDaysMilli = 1 * 24 * 60 * 60 * 1000;
export const sevenDaysMilli = 604800000;
export const thirtyDaysMilli = 2592000000;
export const ninetyDaysMilli = 7776000000;

// Delay Constants (Milliseconds)
export const emailListDelay = 800;
export const companyDropdownSearchDelay = 200;
export const jobSearchDelay = 250;
export const peopleSearchDelay = 250;
export const logResultDelay = 1500;
export const multipleSendClicksDelay = 600;
export const waitForIndex = 700;
export const cacheTimeForClientTable = 1000 * 60 * 10;

// Default cache time is 5 mns
export const defaultCacheTime = 5 * oneMinuteMilli;

export const autoDismissNotificationTime = 10 * oneSecondMilli;

export const cognitiveDisagreementStandardErrorThreshold = 18;

/* END Time */

// DATE FORMATS
// NOTE: This is luxon specific
export const dateFormatStandard = 'dd LLLL yyyy, h:mm a'; // 05 August 2019, 3:09 pm

export const timeToWaitForReminder = 14 * oneDaysMilli;

export const jobMatchCutoff = {
    [JobMatchValue.Great]: 9,
    [JobMatchValue.Ok]: 6,
    [JobMatchValue.Low]: 0
};

// Ask Me Anything
export const askMeAnythingConstants = {
    updateIntervalSeconds: 10,
    placeholderValues: [
        'askMeAnything.question-1',
        'askMeAnything.question-2',
        'askMeAnything.question-3',
        'askMeAnything.question-4',
        'askMeAnything.question-5',
        'askMeAnything.question-6',
        'askMeAnything.question-7',
        'askMeAnything.question-8',
        'askMeAnything.question-9',
        'askMeAnything.question-10'
    ]
};

export const setJobTargetIcon = 'fa-cogs';
export const guidedJobTargetIcon = 'fa-list-alt';

// Feature names from Back End to replicate Feature Locking
export const features = {
    forceUrlPartners: 'PartnerForceUrl',
    forceUrlHq: 'HQForceUrl',
    externalUserManagement: 'ExternalUserManagement',
    companyWideEmployeeLink: 'CompanyWideEmployeeLink'
};

export const PI_VERSION = (window as any).PI_VERSION;

// The max number of people currently supported for the api for bulk reports
export const maxBulkReportPersonCount = 20;

export const multiJARecipientLimit = 10;

export const jobBenchmarkNoMatch = {
    id: 'No Match'
};

export const jobBehavioralRangesValidation = {
    minAcceptableValue: -3,
    maxAcceptableValue: 3,
    minRange: 0.5
};

export const englishLanguageLocale = 'en-US';

export const designAppUrlPrefix = '/design/';

export const factorDominance = 'dominance';
export const factorExtraversion = 'extraversion';
export const factorPatience = 'patience';
export const factorFormality = 'formality';

// Only Form5 download supported at this time
export const checkListDownloadFormIdsSupported = [5];

// Required columns for org structure files
export const fieldDefinitions = {
    required: [
        'engage-orgUpload-uploadTemplate.columns-employeeId',
        'engage-orgUpload-uploadTemplate.columns-firstName',
        'engage-orgUpload-uploadTemplate.columns-lastName',
        'engage-orgUpload-uploadTemplate.columns-employeeEmail',
        'engage-orgUpload-uploadTemplate.columns-managersEmployeeId',
        'engage-orgUpload-uploadTemplate.columns-department'
    ],
    optional: [
        'engage-orgUpload-uploadTemplate.columns-nickname',
        'engage-orgUpload-uploadTemplate.columns-middleName',
        'engage-orgUpload-uploadTemplate.columns-location'
    ],
    recommended: [] as string[]
};

export const orgUploadErrorMessageKeyMap: {
    [key: number]: string;
} = {
    [ErrorNumber.RequiredCriteriaInvalid]:
        'engage-orgupload.fileuploadstatus-uploadfailure.filetype',
    [ErrorNumber.RequiredParameterMissing]:
        'engage-orgupload.fileuploadstatus-uploadfailure.norecords',
    [ErrorNumber.ParameterIsInvalid]:
        'engage-orgupload.fileuploadstatus-uploadfailure.badheader',
    [ErrorNumber.InternalError]:
        'engage-orgupload.fileuploadstatus-uploadfailure.emptyfile',
    [ErrorNumber.LimitExceeded]:
        'engage-orgupload.fileuploadstatus-uploadfailure.sizelimit'
};

export const engageEmailDateOffsets = {
    reminder1: 7,
    reminder2: 10,
    reminder3: 13,
    endCloseDate: 14
};

export const engageFieldDefinitions = {
    required: [
        'engage-orgUpload-uploadTemplate.columns-employeeId',
        'engage-orgUpload-uploadTemplate.columns-firstName',
        'engage-orgUpload-uploadTemplate.columns-lastName',
        'engage-orgUpload-uploadTemplate.columns-employeeEmail',
        'engage-orgUpload-uploadTemplate.columns-managersEmployeeId',
        'engage-orgUpload-uploadTemplate.columns-department'
    ],
    optional: [
        'engage-orgUpload-uploadTemplate.columns-nickname',
        'engage-orgUpload-uploadTemplate.columns-middleName',
        'engage-orgUpload-uploadTemplate.columns-yearOfBirth',
        'engage-orgUpload-uploadTemplate.columns-yearOfHire',
        'engage-orgUpload-uploadTemplate.columns-gender',
        'engage-orgUpload-uploadTemplate.columns-location',
        'engage-orgUpload-uploadTemplate.columns-employeeLevel',
        'engage-orgUpload-uploadTemplate.columns-isExcludedFromSurvey'
    ],
    recommended: ['engage-orgUpload-uploadTemplate.columns-performanceRating']
};

export type CognitiveTimeEntry = {
    key: string;
    value: number;
};

export const standardCognitiveTime: CognitiveTimeEntry = {
    key: 'personDashboard.cognitiveTime-standard',
    value: 12
};

export const cognitiveTimes: CognitiveTimeEntry[] = [
    standardCognitiveTime,
    {
        key: 'personDashboard.cognitiveTime-extended',
        value: 18
    },
    {
        key: 'personDashboard.cognitiveTime-extended',
        value: 24
    }
];

// Keyboard Keys Constants
export const enterKey = 'Enter';
export const arrowUpKey = 'ArrowUp';
export const arrowDownKey = 'ArrowDown';
export const tabKey = 'Tab';

export const errorPageQueryString = 'errorType';
export type PageErrorType =
    | 'outOfSyncUser' // This is the error we expect when you have authenticated with auth 0 but we can not find your user info
    | 'loginError' // Error that occurs during the login process.
    | 'unknown';

export const defaultJobRangeSpread = 0.5;

// Custom Header Keys, synced to match with backend

export const headerIds = {
    apiKey: 'api-key',
    totalCount: 'x-total-count',
    requestingModule: 'RequestingModule'
};

export type togglerWithWarningObject = {
    showWarning: boolean;
    isTogglerEnabled: boolean;
    togglerText: string;
    togglerWarningText: string;
    leftButtonText: string;
    rightButtonText: string;
};

export const moduleName = {
    designSelfServe: 'DesignSelfServe',
    designLegacy: 'DesignLegacy',
    hireHero: 'HireHero',
    diagnose2: 'Diagnose2',
    inspire2: 'Inspire'
};

export type warningTextsObject = {
    warningText: string;
    leftButtonText: string;
    rightButtonText: string;
};

export type upgradeStatus = {
    status: 'success' | 'error';
    method: 'chiliPiper' | 'email';
};

export type upgradeButtonLocation = 'header' | 'paywall' | '';

// Hire Constants - used outside of pi-client-hire

export const Hire2Link = '/hire';

export type TargetFactorRanges = {
    aSigmaRangeLow: number;
    aSigmaRangeHigh: number;
    bSigmaRangeLow: number;
    bSigmaRangeHigh: number;
    cSigmaRangeLow: number;
    cSigmaRangeHigh: number;
    dSigmaRangeLow: number;
    dSigmaRangeHigh: number;
};

export const PrivacyLink = 'https://www.predictiveindex.com/privacy/';

export const FakeStrengths = [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    'Suspendisse pretium magna sed congue suscipit',
    'Maecenas sed arcu hendrerit tortor suscipit lobortis eget sed arcu'
];
export const FakeWorkStyles = [
    'Suspendisse nec turpis consequat, aliquet dui non, blandit mauris',
    'Praesent faucibus dui non lorem lobortis, a faucibus lectus pulvinar',
    'Vivamus quis velit fermentum, scelerisque elit tempor, placerat erat'
];
export const FakeBlindSpots = [
    'Lorem ipsum dolor sit amet',
    'consectetur adipiscing elit',
    'Suspendisse pretium magna sed congue suscipit'
];

/* Sigmas */
export const SigmaZero = '0';
export const SigmaMinusOne = '-1σ';
export const SigmaMinusTwo = '-2σ';
export const SigmaMinusThree = '-3σ';
export const SigmaOne = '+1σ';
export const SigmaTwo = '+2σ';
export const SigmaThree = '+3σ';

export const RedirectURLMaxLength = 256;

export const IntercomAppId = 'wt6gvdr6';
